export default {
	admin: 'gear',
	downloader: 'download',
	editor: 'pencil',
	saveTo: 'folder',
	uploader: 'upload',
	verified: 'check',
	viewer: 'eye',
	breedmaintainer: 'egg',
}
